module.exports = __webpack_public_path__ + "arrows.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/arrows.svg?color1=%23333333&color2=
// module id = 2181
// module chunks = 67